import { UnifiedFieldIcon } from '@modules/common/components/UnifiedFieldIcon';
import { Box, Stack, Tooltip, Typography } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-pro';
import { EqlFieldMetadataReference } from 'generated/graphql';
import { MetadataSampleValue } from '../components/MetadataSampleValue';
import { UnifiedFieldSourceFieldTooltipContent } from '../components/UnifiedFieldSourceFieldTooltipContent';

const MAX_SOURCES_TO_SHOW = 3;

export const useGetUnifiedFieldsColumns = (): GridColDef[] => {
  return [
    {
      field: 'name',
      headerName: 'Unified Fields',
      display: 'flex',
      renderHeader: (params) => (
        <Stack
          spacing={1}
          alignItems="center"
          justifyContent="center"
          direction="row"
        >
          <UnifiedFieldIcon fill="currentColor" />
          <Box component="span">{params.colDef.headerName}</Box>
        </Stack>
      ),
      width: 280,
    },
    {
      field: 'totalMergeFields',
      headerName: 'Fields Merged',
      display: 'flex',
      width: 200,
    },
    {
      field: 'sources',
      headerName: 'Sources Fields are from',
      width: 200,
      display: 'flex',
      renderCell: (params) => {
        const metadataReferences: EqlFieldMetadataReference[] =
          params.row.sources ?? [];

        return (
          <Tooltip
            title={
              <UnifiedFieldSourceFieldTooltipContent
                displayName={params.row.name}
                metadataReferences={metadataReferences}
              />
            }
          >
            <Stack direction="row" alignItems="center" spacing={0.5}>
              {metadataReferences
                .slice(0, MAX_SOURCES_TO_SHOW)
                .map((metadataReference: EqlFieldMetadataReference) => {
                  return (
                    <Box
                      key={metadataReference.key}
                      component="img"
                      width="16px"
                      height="auto"
                      src={metadataReference.iconURL}
                      alt={metadataReference.source}
                      loading="lazy"
                    />
                  );
                })}
              {metadataReferences.length > MAX_SOURCES_TO_SHOW && (
                <Typography variant="body2" color="text.secondary">
                  +{metadataReferences.length - MAX_SOURCES_TO_SHOW}
                </Typography>
              )}
            </Stack>
          </Tooltip>
        );
      },
    },
    {
      field: 'sampleValues',
      headerName: 'Sample Values',
      type: 'number',
      flex: 1,
      display: 'flex',
      renderCell: (params) => {
        return <MetadataSampleValue metadataKey={params.row.field} />;
      },
    },
  ];
};
